import { createAction, handleActions } from 'redux-actions';
// api
import api from '../../utils/api';

const initialState = {
  terms: null,
  privacy: null,
  support: null,
  about_us: null,
  pageOnLoading: null,
  isLoading: false
};

// const
export const GET_PAGE = 'staticPages/GET_PAGE';

// action creators
export const getPage = createAction(GET_PAGE, data => {
  return {
    promise: api.staticPages.getPage(data),
    data
  };
});

// reducer
const reducer = handleActions(
  {
    [`${GET_PAGE}_REQUEST`]: (state, { payload }) => {
      return {
        ...state,
        pageOnLoading: payload,
        isLoading: true
      };
    },
    [`${GET_PAGE}_SUCCESS`]: (state, { payload: { resource } }) => {
      return {
        ...state,
        [state.pageOnLoading]: resource,
        pageOnLoading: null,
        isLoading: false
      };
    },
    [`${GET_PAGE}_ERROR`]: state => {
      return {
        ...state,
        pageOnLoading: null,
        isLoading: false
      };
    }
  },
  initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/staticPages.js